<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <form @submit.prevent="submitEmail">
          <v-card
            class="mx-auto"
            max-width="500"
          >
            <v-card-title class="bg-primary d-flex align-center">
              <div class="banner-side d-flex align-center">
                <v-btn
                  color="white"
                  icon
                  to="/login"
                >
                  <v-icon size="large">
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </div>
              <span
                class="text-h5 white-text text-center"
                style="word-break: break-word"
              >
                Forgot Password?
              </span>
              <div class="banner-side" />
            </v-card-title>
            <v-divider />
            <v-card-text style="height: 200px">
              <div
                v-if="!saved"
                style="font-size: medium"
                class="mt-6"
              >
                <span>Please enter your registered email address. We will send you a link to reset your password.</span>
              </div>
              <div>
                <div v-if="!saved">
                  <v-text-field
                    v-model="email"
                    label="Email"
                    prepend-icon="mdi-email"
                    :rules="emailRules"
                    type="email"
                  />
                </div>
                <v-row style="justify-content: center">
                  {{ message }}
                </v-row>
              </div>
              <div
                v-if="saved"
                class="mt-12"
                style="font-size: medium"
              >
                If {{ email }} is registered, a link to reset your password
                was sent to your email.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-row
                class="mb-4 mr-2"
                justify="end"
              >
                <v-btn
                  v-if="!saved"
                  class="ml-2"
                  color="primary"
                  type="submitEmail"
                >
                  <span>Send Email</span>
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      message: "",
      email: "",
      emailRules: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      saved: false,
      canSave: false,
      loginPath: "/login",
    };
  },
  computed: {
    ...mapGetters({
      user: "reset/user",
    }),
  },
  async created() {
    this.message = "";
  },
  methods: {
    ...mapActions({
      sendPasswordEmail: "reset/sendPasswordEmail",
    }),
    async submitEmail() {
      try {
        await this.sendPasswordEmail({
          email: this.email,
        });
        this.saved = true;
      } catch (e) {
        console.log(e);
        this.saved = false;
      }
    },
  },
};
</script>

<style scoped>
.banner-side {
  flex: 1 1 0;
}
</style>
